"use strict";

exports.__esModule = true;
exports.ChainConfig = exports.Apis = undefined;

var _ApiInstances = require("./src/ApiInstances");

var _ApiInstances2 = _interopRequireDefault(_ApiInstances);

var _ChainConfig = require("./src/ChainConfig");

var _ChainConfig2 = _interopRequireDefault(_ChainConfig);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

exports.Apis = _ApiInstances2.default;
exports.ChainConfig = _ChainConfig2.default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/dcorejs-lib/lib/ws/cjs/index.js
// module id = 15
// module chunks = 0